import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PDFState {
  viewsReady: string[];
  expectedViews: string[];
  renderReady: boolean;
}

const initialState: PDFState = {
  viewsReady: [],
  expectedViews: [],
  renderReady: false,
};

const pdfSlice = createSlice({
  name: "pdf",
  initialState,
  reducers: {
    addExpectedView(state, action: PayloadAction<string>) {
      if (!state.expectedViews.includes(action.payload)) {
        state.expectedViews.push(action.payload);
      }
    },
    viewRendered(state, action: PayloadAction<string>) {
      if (!state.viewsReady.includes(action.payload)) {
        state.viewsReady.push(action.payload);
      }
    },
    setRenderReady(state, action: PayloadAction<boolean>) {
      state.renderReady = action.payload;
    },
    resetPDFState(state) {
      state.viewsReady = [];
      state.expectedViews = [];
      state.renderReady = false;
    },
  },
});

export const {
  addExpectedView,
  viewRendered,
  setRenderReady,
  resetPDFState,
} = pdfSlice.actions;

export default pdfSlice.reducer;
